<template>
    <div id="daumContent" class="cont_cafe">
        <article id="mArticle" class="apply_list">
            <apply-list-info v-bind="propsToInfo"></apply-list-info>
            <p class="box_desc"><em class="apply_article_total">{{ articleCount.toLocaleString() }}</em>명이 참여하였습니다.</p>
            <ul id="apply_list" class="list_applicant" :class="{ list_type2: isMore }">
                <template v-if="info.type === 'apply'">
                    <li v-for="(article, index) in articleList" :key="index" :data-dataid="article.dataid">
                        <a :href="articleLinkBy(article.dataid)" class="link_applicant">
                            <span class="txt_nickname"><strong>{{ article.writer.nickName }}</strong> 님이 참여하였습니다.</span>
                            <span class="wrap_info">
                                <time class="txt_date">{{ article.applydate }}</time>
                                <span class="txt_replay" v-if="article.hasReply">답변 1</span>
                            </span>
                        </a>
                    </li>
                </template>
                <template v-else>
                    <li v-for="(article, index) in articleList" :key="index" :data-dataid="article.dataid">
                        <a :href="articleLinkBy(article.dataid)" class="link_applicant">
                            <span class="txt_nickname" :class="article.status">
                                <span v-if="article.writer.private">
                                    <strong>[{{ statusToKorean(article.status) }}]</strong> {{ article.writer.nickName }}(비공개)
                                </span>
                                <span v-else-if="article.writer.exist">
                                    <strong>[{{ statusToKorean(article.status) }}]</strong> {{ article.writer.nickName }}({{ article.writer.email }})
                                </span>
                                <span v-else>
                                    <strong>[{{ statusToKorean(article.status) }}]</strong> {{ article.writer.nickName }}
                                </span>
                            </span>
                            <span class="wrap_info">
                                <time class="txt_date">{{ article.applydate }}</time>
                                <span class="txt_replay" v-if="article.hasReply">답변 1</span>
                            </span>
                        </a>
                    </li>
                </template>
            </ul>
            <button type="button" id="btn_list_more" class="btn_applicant" @click="getApplyList" v-if="isMore">
                <span class="ico_cafe">더보기</span>
            </button>
        </article>
    </div>
</template>

<script>
import ApplyListInfo from './ApplyListInfo.vue';

export default {
    components: {
        ApplyListInfo
    },
    data() {
        return {
            isAdmin: APPLY_LIST_PROPS.IS_ADMIN,
            grpId: CAFEAPP.GRPID,
            grpCode: CAFEAPP.GRPCODE,
            fldId: CAFEAPP.FLDID,
            boardName: CAFEAPP.BOARDNAME,
            
            isMore: false,
            isFinish: false,
            info: {},
            articleCount: 0,
            articleList: []
        };
    },
    computed: {
        lastArticleId() {
            if(!this.articleList.length) return 0;
            return this.articleList[this.articleList.length - 1].dataid;
        },
        propsToInfo() {
            return {
                ...this.info
            };
        }
    },
    methods: {
        actionIncomplete(xhr) {
            alert(cafe.EXCEPTION.getMessage(xhr));
            if(xhr.responseJSON && xhr.responseJSON.code == 104){
                window.location.href = `/${this.grpCode}/`;
            } else {
                window.location.href = `/${this.grpCode}/${this.fldId}?boardType=L`;
            }
        },
        setArticleData(data) {
            this.isMore = data.more;
            this.isFinish = data.finish;
            this.articleCount = data.count;
            this.info = data.info;
            this.articleList = [...this.articleList, ...data.apply_list];

            window.registerTiara("applyArticleList", data.info.type);
        },
        getApplyList() {
            $.ajax(`/_apply/${this.grpId}/${this.fldId}?lastArticleId=${this.lastArticleId}&count=20`)
                .then(this.setArticleData, this.actionIncomplete);
        },
        articleLinkBy(dataId) {
            return `/${this.grpCode}/${this.fldId}/${dataId}?boardType=L`;
        },
        statusToKorean(status) {
            const statusMap = {
                apply: "신청",
                progressing: "진행",
                return: "리턴",
                done: "완료"
            };
            return statusMap[status];
        }
    },
    created() {
        this.getApplyList(this.lastArticleId);
    }
}
</script>
